import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AccessService } from '../services/service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(private router: Router, private access: AccessService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const role = next.data['permission'];

    let hasPermission = true;

    if (role) {
      hasPermission = this.access.hasPermission(role);
    }

    if (!hasPermission) {
      this.router.navigate(['/home']);
    }

    return hasPermission;
  }
}
